module.exports = __webpack_public_path__ + "img/restart_button_hover.3c0a597b.png";